module.exports = __webpack_public_path__ + "img/ic-top-navi-users.22b5df16.svg";